import axios from 'axios'

const baseURL = process.env.VUE_APP_API_BASEURL || ''

const api = axios.create({
    baseURL : `${baseURL}/wp-content/data/`,
    timeout : 5000,
})

export default api